/** @jsxImportSource @emotion/react */
import React, { useLayoutEffect, useRef } from 'react';

import ExternalLink from '../ExternalLink';
import useStyles from './styles';

const SkipToMainButton = ({
  isVisible,
  setIsVisible,
  setSkipCounter,
  currentPage,
}) => {
  const styles = useStyles();
  const skipLinkRef = useRef(null);

  useLayoutEffect(() => {
    if (isVisible && skipLinkRef.current) {
      skipLinkRef.current.focus();
    }
  }, [isVisible]);

  isVisible && setSkipCounter(1);

  const handleBlur = () => {
    setIsVisible(false);
  };

  const handleClick = e => {
    e.preventDefault();
    const mainContent = document.getElementById('main-content');

    const buttonId = {
      homepage: 'cta_start_searching_now',
      recommendationspage: 'recommended_football_type_cta_view_start_search',
      teampage: 'back_to_results',
      clubpage: 'back_to_results',
    }

    if (
      currentPage === 'homepage' ||
      currentPage === 'recommendationspage' ||
      currentPage === 'teampage' ||
      currentPage === 'clubpage'
    ) {
      const onboardingButton = document.getElementById(buttonId[currentPage]);
      onboardingButton.focus();
      if (mainContent) {
        mainContent.scrollIntoView({ behavior: 'smooth' });
      }
    }
  
    setIsVisible(false);
    setSkipCounter(2);
  };

  return (
    <ExternalLink
      css={[
        styles.skipToMainLinkHidden,
        isVisible && styles.skipToMainLinkVisible,
      ]}
      href="#main-content"
      ref={skipLinkRef}
      tabIndex={0}
      onBlur={handleBlur}
      onClick={handleClick}
    >
      Skip to main content
    </ExternalLink>
  );
};

export default SkipToMainButton;
